<div class="alert alert-info alert--small mt-2" *ngIf="!featureEnabled">
  This is a sample breadcrumb. Breadcrumbs are a snapshot of events that lead up
  to a specific error occurrence.
</div>
<div
  class="ab-breadcrumb"
  *ngFor="let state of contextHistory; trackBy: trackBy"
  [ngSwitch]="state.type"
  [ngClass]="{ 'breadcrumb--sample': !featureEnabled }"
>
  <div class="ab-breadcrumb__item ab-breadcrumb__item--date">
    <span class="text-small">{{ state.date | date: "HH:mm:ss" }}</span>
  </div>
  <div class="ab-breadcrumb__item ab-breadcrumb__item--type">
    <span
      class="ab-breadcrumb-hexagon"
      [ngClass]="{
        'bkg-color--blue-400': state.type === 'location',
        'bkg-color--orange-400': state.type === 'log',
        'bkg-color--blue-600': state.type === 'xhr',
        'bkg-color--grey-500': state.type === 'DOMContentLoaded',
        'bkg-color--grey-700': state.type === 'load',
        'bkg-color--danger': state.type === 'error',
        'bkg-color--green-400':
          state.type === 'keypress' || state.type === 'click'
      }"
      [ngSwitch]="state.type"
    >
      <span *ngSwitchCase="'location'">GO</span>
      <span *ngSwitchCase="'keypress'">KEY</span>
      <span *ngSwitchCase="'DOMContentLoaded'">DOM</span>
      <span *ngSwitchCase="'error'">ERR</span>
      <span *ngSwitchDefault>{{ state.type }}</span>
    </span>
  </div>
  <div class="ab-breadcrumb__item ab-breadcrumb__item--severity">
    {{ state.severity }}
    {{ state.method }}
  </div>
  <div class="ab-breadcrumb__item ab-breadcrumb__item--message">
    <span *ngSwitchCase="'log'">
      <pre
        class="color--red-300"
        *ngFor="let arg of state.arguments; trackBy: trackBy"
      >
        <span *ngIf="!arg">{{arg | json}}</span>
        <span *ngIf="arg">{{arg}}</span>
      </pre>
    </span>
    <span *ngSwitchCase="'xhr'">
      <code>{{ state.url }} with code {{ state.statusCode }}</code>
    </span>
    <span *ngSwitchDefault>
      <span *ngIf="state.type === 'location'">
        From<code class="color--grey-400">{{ state.from }}</code
        >to
        <code class="color--grey-400">{{ state.to }}</code>
      </span>
      <span *ngIf="state.type === 'DOMContentLoaded'"
        >DOM content is loaded</span
      >
      <span *ngIf="state.type === 'load'">Window is fully loaded</span>
      <span *ngIf="state.type === 'error'"
        >Error loading {{ state.target }}</span
      >
      <span *ngIf="state.type === 'click'"
        >Click on<code class="color--grey-400">{{ state.target }}</code></span
      >
      <span *ngIf="state.type === 'keypress'"
        >Type in<code class="color--grey-400">{{ state.target }}</code></span
      >
    </span>
  </div>
  <div
    class="ab-breadcrumb__item ab-breadcrumb__item--duration text-small"
    *ngIf="state.duration"
  >
    in {{ state.duration }}ms
  </div>
</div>
<button
  class="btn btn--upgrade ab-breadcrumb__upgrade-button"
  (click)="openUpgradeModal($event)"
  *ngIf="!featureEnabled"
  data-feature="breadcrumbs"
  type="button"
>
  Enable Breadcrumbs
</button>
